import React from "react";
import { Row, Col } from "react-bootstrap";
import iconoPresupuestar from "../assets/presup-ico.png";

const Cta = () => {
  return (
    <Row>
      <Col md={12} className="text-center">
        <h3>¿Listo para tu nueva piscina?</h3>
        <p>Ingresá a nuestro cotizador y encontrá tu piscina.</p>
        <a
          href="https://piscinasipc.com/cotizador"
          target="_blank"
          className="box"
          rel="noreferrer"
        >
          <span>
            <img src={iconoPresupuestar} alt="Piscinas IPC"></img> Presupuestar
          </span>
        </a>
      </Col>
    </Row>
  );
};

export default Cta;
